import Page404 from './components/Page404';


export default {
  path : '*',
  component : Page404,
};



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/Page404/index.js